module.exports = __webpack_public_path__ + "img/type2_uncheck1.0a826818.png";